import { useEffect } from 'react';

const PREHYDRATION_ATTR = 'data-prehydration';

/**
 * Manages the `data-prehydration` attribute lifecycle on a root element.
 * Removes the attribute after React hydration, using a double rAF
 * to ensure React's state updates are committed before disabling
 * the CSS pre-hydration fallback rules.
 */
export const usePreHydrationCleanup = (
  rootRef: React.RefObject<HTMLElement | null>,
  isEnabled: boolean,
) => {
  useEffect(() => {
    if (!isEnabled) {
      return;
    }

    const root = rootRef.current;
    if (!root?.hasAttribute(PREHYDRATION_ATTR)) {
      return;
    }

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        root.removeAttribute(PREHYDRATION_ATTR);
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEnabled]);
};
